export class CopySiteAndTransformSettings {

    public dataCollectionId: number;
    public newName: string;
    public jsonConfig: string;
    public countOfFormInstancesToExport: number = -1; // useful for debugging. Set to -1 when you want to include all FormInstances in the export 

    constructor(dataCollectionId: number, newName: string, jsonConfig: string, countOfFormInstancesToExport: number = -1) {
        this.dataCollectionId = dataCollectionId;
        this.newName = newName;
        this.jsonConfig = jsonConfig;
        this.countOfFormInstancesToExport = countOfFormInstancesToExport;
    }
}
